export default __webpack_public_path__ + "static/media/icon-head-unknown.f99c4f4d.png";